import { createSelector } from 'reselect';
import { transformLitterReport } from './trasnformer';

export const getHomeState = (state) => state.home || {};

export const getCountries = createSelector(
    getHomeState,
    (state) => state.countries,
);

export const getTags = createSelector(getHomeState, (state) => state.tags);

export const isReportLoading = createSelector(
    getHomeState,
    (state) => state.isReportLoading,
);

export const getLitterReport = createSelector(getHomeState, (state) =>
    transformLitterReport(state.litterReport),
);

export const getSelectedLitterReportFilter = createSelector(
    getHomeState,
    (state) => state.selectedFilter,
);

export const getLitterReportCount = createSelector(
    getHomeState,
    (state) => state.litterReportCount,
);

export const getFormDetails = createSelector(
    getHomeState,
    (homeState) => homeState.formDetails,
);

export const getFormMessage = createSelector(
    getHomeState,
    (homeState) => homeState.formMessage,
);

export const getReportRequestDetails = createSelector(
    getHomeState,
    (state) => state.requestDetails,
);

export const getSendReportError = createSelector(
    getHomeState,
    (state) => state.sendReportError,
);

export const getSendReportSuccessMessages = createSelector(
    getHomeState,
    (state) => state.sendReportSuccessMessages,
);
export const getReportSuccessMessage = createSelector(
    getHomeState,
    (state) => state.reportSuccess,
);

export const isReportSendingInProgress = createSelector(
    getHomeState,
    (state) => state.isReportSendingInProgress,
);
export const isFormSubmitting = createSelector(
    getHomeState,
    (state) => state.isFormSubmitting,
);

export const getMapData = createSelector(
    getHomeState,
    (state) => state.mapData,
);

export const isMapLoading = createSelector(
    getHomeState,
    (state) => state.isMapLoading,
);
